module.exports = __webpack_public_path__ + "img/horcrux-marvolo-gaunt.d11c137e.png";